import { render, staticRenderFns } from "./select-reason-type.vue?vue&type=template&id=442f8866&"
import script from "./select-reason-type.vue?vue&type=script&lang=js&"
export * from "./select-reason-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports